import { useTranslation } from "react-i18next";
import styles from "../styles/receipt.module.css";

export default function TableFooter({
  page,
  setPage,
  totalPages,
  next,
  previous,
  count = 0,
  loading = false,
}) {
  const { t } = useTranslation();
  return (
    <div className={styles["table-footer"]}>
      <p style={{ color: "var(--text-secondary)", fontSize: "0.9rem" }}>
        {loading ? (
          <span style={{ color: "#f97316", fontSize: "0.83rem" }}>
            <i
              className="fa-solid fa-circle-notch fa-spin"
              style={{ marginRight: 5 }}
            />
            {t("common.cargando")}
          </span>
        ) : (
          <>
            <span>{count}</span> {t("common.resultados")} · {t("common.pagina")} <span>{page}</span>{" "}
            {t("common.de")} <span>{Math.max(1, totalPages)}</span>
          </>
        )}
      </p>

      <div className={`${styles["pagination-buttons"]} d-flex gap-2`}>
        <button
          disabled={!previous || loading}
          onClick={() => setPage((p) => p - 1)}
          className={`btn btn-sm ${styles["btn-prev"]} d-flex gap-2 align-items-center`}
        >
          {t("common.anterior")}
        </button>
        <button
          disabled={!next || loading}
          onClick={() => setPage((p) => p + 1)}
          className={`btn btn-sm ${styles["btn-next"]} d-flex gap-2 align-items-center`}
        >
          {t("common.siguiente")}
        </button>
      </div>
    </div>
  );
}
